import { ReactNode } from 'react';
import cn from 'classnames';
import { FCX } from "@datassential/platform-ui-lib";
import { FaCheck } from "react-icons/fa";

export enum ToggleType {
    Checkbox = 'check',
    Radio = 'radio',
    RoundCheckbox = 'round-check',
}

type modifiers = 'inverted';

const Toggle: FCX<{
    isChecked: boolean;
    isDisabled?: boolean;
    onChange: () => void;
    label?: ReactNode;
    type?: ToggleType;
    labelPosition?: 'right' | 'left';
    modifiers?: modifiers[];
}> = ({
    type = ToggleType.Radio,
    isChecked,
    isDisabled,
    onChange,
    label,
    labelPosition = 'right',
    className,
    style,
    modifiers = [],
    testId,
    ...attrs
}) => {
    return (
        <div
            onClick={onChange}
            className={cn(
                "Toggle",
                className,
                `is-${type}`,
                isChecked && 'is-checked',
                isDisabled && 'is-disabled',
                ...modifiers.map(i => `is-${i}`),
            )}
            {...attrs}
            style={{
                ...style,
                flexDirection: labelPosition === 'right' ? 'row' : 'row-reverse',
            }}
            data-testid={testId}
        >
            <div className="Toggle__icon">
                <FaCheck/>
            </div>
            {!!label && (
                <div className="Toggle__label">
                    {label}
                </div>
            )}
        </div>
    );
};

export default Toggle;